import { Controller } from "@hotwired/stimulus"

// Delivery section on the Review step: reveal the date/time inputs only when
// "Schedule for later" is chosen. The chosen mode (campaign[delivery_mode]) is
// submitted with the form and routed by the controller (send now vs schedule).
export default class extends Controller {
  static targets = ["mode", "schedule"]

  connect() { this.toggle() }

  toggle() {
    const scheduled = this.modeTargets.some((r) => r.checked && r.value === "schedule")
    if (this.hasScheduleTarget) this.scheduleTarget.classList.toggle("d-none", !scheduled)
  }
}
